import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { GetUsersResponseType, Organisation, UserInfo } from '../../models/types'; // Ensure UserInfo type is imported correctly
import { Router } from '@angular/router';
import { ProfilePageService } from '../services/profile-page.service';
import { LoginService } from '../services/login.service';


@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfilePageComponent implements OnInit {

  user: GetUsersResponseType | undefined;
  allOrganisations: Organisation[] = [];
  selectedOrganisations: number[] = [];

  currentUserId: number = 0;

  isUserEditMode: boolean = false;
  errorMessage: string = '';

  constructor(
    private profilePageService: ProfilePageService,
    private loginService: LoginService,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log('UserProfilePage initialized.');
    this.fetchUserData();
    this.loadOrganisations();
  }

  loadOrganisations() {
    this.loginService.getAllOrganisations().subscribe({
      next: (response) => {
        // Check the response structure
        console.log('Raw response:', response);
  
        // Extract the organisations array from the response body
        if (response.body && Array.isArray(response.body.organisations)) {
          this.allOrganisations = response.body.organisations.filter((org: Organisation) => org.organisationID !== -1);
        } else {
          console.error('Unexpected response structure:', response.body);
        }
        console.log('Organisations fetched:', this.allOrganisations);
      },
      error: (err) => {
        console.error('Error fetching organisations:', err);
      }
    });
  }

  fetchUserData(): void {
    this.currentUserId = this.loginService.GetLoggedInUserInfo()?.userID || 0;
    this.profilePageService.getUserProfile(this.currentUserId).subscribe(
      (response) => {
        this.user = response.body!;
        console.log('User data loaded successfully:', this.user);
      },
      (error) => {
        this.errorMessage = 'Error loading user data';
        console.error('Error loading user data:', error);
      }
    );
  }

  onOrganisationSelected(organisationID: number, event: any): void {
    if (event.target.checked) {
      // Find the organisation from allOrganisations
      const selectedOrganisation = this.allOrganisations.find(org => org.organisationID === organisationID);
      if (selectedOrganisation && !this.user!.organisations!.some(org => org.organisationID === organisationID)) {
        this.user!.organisations!.push(selectedOrganisation);
      }
    } else {
      // Remove the organisation from user.organisations
      this.user!.organisations = this.user!.organisations!.filter(org => org.organisationID !== organisationID);
    }
  }
  

  isOrganisationSelected(organisationID: number): boolean {
    return this.user!.organisations!.some(org => org.organisationID === organisationID);
  }

  saveUser(): void {
    this.profilePageService.updateUserProfile(this.user!).subscribe(
      (response: any) => {
        this.toggleUserEditMode();
        this.fetchUserData();
        console.log('User data saved successfully:', response);
      },
      (error: any) => {
        this.errorMessage = 'Error saving user data';
        console.error('Error saving user data:', error);
      }
    );
  }

  toggleUserEditMode(): void {
    this.isUserEditMode = !this.isUserEditMode;
  }
  getSelectedOrganisationIds(): number[] {
    return this.user!.organisations!.map(org => org.organisationID);
  }

}

